<template>
	<div>
		<div class="cgqBox">
			<div class="cgqBoxTil">
				{{list.data.menuTitle}}
			</div>
			<div class="cgqBoxSp" :style="{
				paddingRight:bj+'px'
			}">
				<img :src="list.data.imgs" />
				<!-- <video></video> -->
			</div>
			<div class="data31Box">
				<div class="swiper-hexinTwo" :class="`swiper-hexinTwo${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide swiper-slideTwo" v-for="(item,index) in list.data.content"
							:key="index">
							<div class="data31BoxList">
								<div class="data31BoxListImg">
									<img :src="item.cover" />
								</div>
								<div class="data31BoxListImgTwo">
									<img :src="item.icon" />
								</div>
								<div class="data31BoxListWz">
									<div class="data31BoxListWzName">
										{{item.title}}
									</div>
									<div class="data31BoxListWzCen">
										<div v-for="(itema,indexa) in item.desc" :key="indexa">{{itema.text}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<template v-if="headerShow">
						<div class="swiper-hexin-prev" :style="{
							left:bj+'px'
						}">
							<img src="@/assets/product/page6/zjt.png" />
						</div>
						<div class="swiper-hexin-next" :style="{
							right:bj+'px'
						}">

							<img src="@/assets/product/page6/yjt.png" />
						</div>
					</template>
					<template v-else>
						<div class="swiper-hexin-prev" :style="{
							left:'30px'
						}">
							<img src="@/assets/product/page6/zjt.png" />
						</div>
						<div class="swiper-hexin-next" :style="{
							right:'30px'
						}">

							<img src="@/assets/product/page6/yjt.png" />
						</div>
					</template>

				</div>
			</div>
			<div class="data31Box" v-if="false" :style="{
				paddingRight:bj+'px',
				paddingLeft:bj+'px'
			}">
				<div class="data31BoxList" v-for="(item,index) in list.data.content" :key="index">
					<div class="data31BoxListImg">
						<img :src="item.cover" />
					</div>
					<div class="data31BoxListImgTwo">
						<img :src="item.icon" />
					</div>
					<div class="data31BoxListWz">
						<div class="data31BoxListWzName">
							{{item.title}}
						</div>
						<div class="data31BoxListWzCen">
							<div v-for="(itema,indexa) in item.desc" :key="indexa">{{itema.text}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				bj: ''
				// list: [{
				// 		img: require('@/assets/product/page8/ledgy.png'),
				// 		imgTwo: require('@/assets/product/page11/dgcsj.png'),
				// 		name: '大视场角',
				// 		cen: '- 140°大视场角- 减少信息遗漏'
				// 	},
				// 	{
				// 		img: require('@/assets/product/page8/ledgy.png'),
				// 		imgTwo: require('@/assets/product/page11/dqd.png'),
				// 		name: '大钳道',
				// 		cen: '- 结肠镜钳道3.7mm- 可匹配绝大多数手术耗材'
				// 	},
				// ]
			}
		},
		watch: {
			bj() {
				let t = this;
				let index = this.list.data.content.length - 2;
				let name = '.swiper-hexinTwo' + this.list.index;
				if (this.headerShow) {
					this.mySwiper = new this.$swiper(name, {
						// 内部Swiper的选项
						direction: 'horizontal',
						widch: 580,
						slidesPerView: 'auto', // 每屏显示3个滑块
						spaceBetween: 40,
						slidesOffsetBefore: t.bj,
						slidesOffsetAfter: t.bj,
						initialSlide: index,
						autoplay: false,
						// 自动播放
						// autoplay: {
						// 	delay: 3000,
						// 	disableOnInteraction: false,
						// },
						allowTouchMove: this.list.data.content.length > 1 ? true : false,
						navigation: {
							prevEl: ".swiper-hexin-prev",
							nextEl: ".swiper-hexin-next",
						},
						on: {
							slideChangeTransitionEnd: function() {
								if (this.activeIndex === 0) {
									t.prev = 'none';
								} else {
									t.prev = 'block';
								}
								if (this.activeIndex === this.slides.length - 1) {
									t.next = 'none';
								} else {
									t.next = 'block';
								}
								if (this.activeIndex === this.slides.length - 2) {
									t.next = 'none';
								} else {
									t.next = 'block';
								}
								// if (t.sliact == this.activeIndex && t.sliact == this.slides.length - 2) {
								// 	t.next = 'none';
								// } else {
								// 	t.sliact = this.activeIndex;
								// }
							},
						},
					});
				} else {
					this.mySwiper = new this.$swiper(name, {
						// 内部Swiper的选项
						direction: 'horizontal',
						slidesPerView: 'auto', // 每屏显示3个滑块
						slidesOffsetBefore: t.bj,
						slidesOffsetAfter: t.bj,
						initialSlide: index,
						autoplay: false,
						// 自动播放
						// autoplay: {
						// 	delay: 3000,
						// 	disableOnInteraction: false,
						// },
						allowTouchMove: this.list.data.content.length > 1 ? true : false,
						navigation: {
							prevEl: ".swiper-hexin-prev",
							nextEl: ".swiper-hexin-next",
						},
						on: {
							slideChangeTransitionEnd: function() {
								if (this.activeIndex === 0) {
									t.prev = 'none';
								} else {
									t.prev = 'block';
								}
								if (this.activeIndex === this.slides.length - 1) {
									t.next = 'none';
								} else {
									t.next = 'block';
								}
								if(this.headerShow){
									if (this.activeIndex === this.slides.length - 2) {
										t.next = 'none';
									} else {
										t.next = 'block';
									}
								}
								
								// if (t.sliact == this.activeIndex && t.sliact == this.slides.length - 2) {
								// 	t.next = 'none';
								// } else {
								// 	t.sliact = this.activeIndex;
								// }
							},
						},
					});
				}

			}
		},
		mounted() {
			this.getWidth()
		},
		methods: {
			getWidth() {
				console.log(document.body.clientWidth, window.screen.availWidth)
				let width = ''
				if (document.body.clientWidth > 1200) {
					width = document.body.clientWidth - 1200;
				} else {
					width = 0;
				}
				this.$nextTick(function() {
					this.bj = width / 2
				})
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.cgqBox {

		padding-bottom: 150px;

		.cgqBoxTil {
			font-size: 45px;
			
			font-weight: bold;
			color: #000000;
			width: 1200px;
			margin: 0 auto;
			margin-bottom: 61px;
		}

		.cgqBoxCen {
			width: 1200px;
			margin: 0 auto;
			font-size: 18px;
			
			font-weight: 300;
			color: #000000;
			margin-bottom: 63px;
		}

		.cgqBoxSp {
			width: 100%;
			// height: 600px;
			padding-right: 160px;
			margin-bottom: 38px;
			box-sizing: border-box;

			img {
				width: 100%;
				height: auto;
			}

			video {
				width: 100%;
				height: auto ;
			}
		}

		.cgqBoxXiao {
			display: flex;
			overflow-x: auto;

			.cgqBoxFor:not(:last-child) {
				margin-right: 40px;
			}

			.cgqBoxFor {
				width: 300px;

				.cgqBoxForImg {
					width: 70px;
					height: 70px;
					margin-bottom: 40px;

					img {
						width: 70px;
						height: 70px;
						object-fit: cover;
					}
				}

				.cgqBoxForName {
					font-size: 26px;
					
					font-weight: 400;
					color: #000000;
					margin-bottom: 32px;
				}

				.cgqBoxForCen {
					font-size: 18px;
					
					font-weight: 300;
					color: #000000;
				}
			}
		}
	}

	.data31Box {
		// padding-left: 160px;
		display: flex;
		width: 100%;

		.data31BoxList:not(:last-child) {
			margin-right: 40px;
		}

		.data31BoxList:hover {
			.data31BoxListImg {
				img {
					// transform: scale(1.1);
				}
			}
		}

		.data31BoxList {

			.data31BoxListImg {
				width: 580px;
				height: 440px;
				overflow: hidden;
				margin-bottom: 40px;

				img {
					width: 580px;
					height: 440px;
					// object-fit: cover;
					transition: all 0.3s ease-in-out;
				}
			}

			.data31BoxListImgTwo {
				margin-bottom: 39px;

				img {
					width: 70px;
					height: 70px;
					// object-fit: cover;
					transition: all 0.3s ease-in-out;
				}
			}

			.data31BoxListWz {
				.data31BoxListWzName {
					margin-right: 20px;
					font-size: 26px;
					
					font-weight: bold;
					color: #000000;
					margin-bottom: 32px;
				}

				.data31BoxListWzCen {
					font-size: 18px;
					
					font-weight: 300;
					color: #000000;

					>div {
						white-space: pre-line;
					}
				}
			}
		}
	}

	.swiper-hexinTwo {
		overflow: hidden;
		position: relative;
		width: 100%;

		.swiper-slideTwo {
			width: 580px;
		}

		.swiper-hexin-prev {
			position: absolute;
			top: 240px;
			left: 260px;
			z-index: 99;
			width: 51px;
			height: 51px;
			cursor: pointer;

			img {
				width: 51px;
				height: 51px;
			}

			border-radius: 100%;
			transform: translateY(-50%);
			transition: all 0.3s ease;

		}

		.swiper-hexin-next {
			transform: translateY(-50%);
			position: absolute;
			top: 240px;
			right: 260px;
			z-index: 99;
			width: 51px;
			height: 51px;
			border-radius: 100%;
			transition: all 0.3s ease;
			cursor: pointer;

			img {
				width: 51px;
				height: 51px;
			}
		}
	}

	@media screen and (max-width:1200px) {
		.cgqBox {
			width: 100% !important;
			padding: 0 30px 30px !important;
			box-sizing: border-box;

			.cgqBoxTil {
				font-size: 24px !important;
				margin-bottom: 20px !important;
				width: 100% !important;
			}

			.cgqBoxCen {
				font-size: 14px !important;
				margin-bottom: 20px !important;
				width: 100% !important;
			}

			.swiper-slide {
				width: 100% !important;
			}

			.cgqBoxSp {
				height: auto !important;
				margin-bottom: 20px !important;

				img {
					height: auto !important;
				}

				video {
					height: auto !important;
				}
			}

			.cgqBoxXiao {
				flex-wrap: wrap;

				.cgqBoxFor:not(:last-child) {
					margin-right: 0px !important;
				}

				.cgqBoxFor:nth-of-type(2n-1) {
					margin-right: 20px !important;
				}

				.cgqBoxFor {
					min-width: calc(50% - 10px) !important;

					.cgqBoxForImg {
						width: 40px;
						height: 40px;
						margin-bottom: 20px !important;

						img {
							width: 40px !important;
							height: 40px !important;
							object-fit: cover;
						}
					}

					.cgqBoxForName {
						font-size: 18px !important;
						margin-bottom: 20px !important;
					}

					.cgqBoxForCen {
						font-size: 14px !important;
					}
				}
			}


		}

		.data31Box {
			.data31BoxList:not(:last-child) {
				margin-right: 20px !important;
			}

			.data31BoxList {
				width: 100% !important;

				.data31BoxListImg {
					margin-bottom: 20px !important;
					width: 100% !important;
					height: auto !important;
					margin-bottom: 20px !important;

					img {
						width: 100% !important;
						height: auto !important;
						object-fit: contain !important;
					}
				}

				.data31BoxListImgTwo {
					margin-bottom: 20px !important;

					img {
						width: 35px !important;
						height: 35px !important;
					}
				}

				.data31BoxListWz {
					.data31BoxListWzName {
						// margin-right: 20px;
						font-size: 18px !important;
						margin-bottom: 20px !important;
					}

					.data31BoxListWzCen {
						font-size: 14px !important;
					}
				}
			}
		}
	}
</style>